export * from './FriendlyCaptcha';
import { isValidFriendlyCaptchaSolution } from './action';

export { isValidFriendlyCaptchaSolution };
